// This file is auto-generated. Run `pnpm generate:icons` to regenerate.
// biome-ignore-all assist/source/organizeImports: Generated file.
// biome-ignore-all format: Generated file.
// biome-ignore-all lint/a11y/noSvgWithoutTitle: Icon accessibility is handled by the Icon wrapper.
import type { SVGProps } from "react";

export default function AddPlusIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 12.72 5.9998 C 12.72 5.6008 12.399 5.2798 12 5.2798 C 11.601 5.2798 11.28 5.6008 11.28 5.9998 V 11.2798 H 6 C 5.601 11.2798 5.28 11.6008 5.28 11.9998 C 5.28 12.3988 5.601 12.7198 6 12.7198 H 11.28 V 17.9998 C 11.28 18.3988 11.601 18.7198 12 18.7198 C 12.399 18.7198 12.72 18.3988 12.72 17.9998 V 12.7198 H 18 C 18.399 12.7198 18.72 12.3988 18.72 11.9998 C 18.72 11.6008 18.399 11.2798 18 11.2798 H 12.72 V 5.9998 Z" fill="currentColor" />
</svg>
  );
}